/* global APPSIGNAL_API_KEY: true */
/* global GIT_REVISION: true */
/* global BACKEND: true */

import Appsignal from "@appsignal/javascript";
import { plugin } from "@appsignal/plugin-path-decorator";

const appsignal = new Appsignal({
  key: APPSIGNAL_API_KEY,
});
appsignal.use(plugin({}))
window.appsignal = appsignal;

function _handleSendError(error, info) {
  if (error) {
    if (error.stack && error.stack.includes('juicebox')) {
      return; // Don't send this error to appsignal
    }
    if (error.message && error.message.includes('sizing.trySetContainerSize')) {
      return; // Don't send this error to appsignal
    }
    appsignal.sendError(error);
  } else {
    appsignal.sendError(new Error('Null error raised, no exception message available'));
  }
}

window.onerror = function(message, filename, lineno, colno, error) {
  _handleSendError(error);
};

export function sendError(error, info) {
  _handleSendError(error, info);
}
